import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { androidDownloadReducer } from "./download-android/reducer";

export const rootReducer = combineReducers({
  androidDownloadReducer: androidDownloadReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const initialState: Partial<RootState> = {};

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
});

export const typedDispatch = store.dispatch;
